import BookingDateDto from "@/models/BookingDates/BookingDateDto";

export default class BookingDateViewModel{
    bookingDate: BookingDateDto = new BookingDateDto();
    dateAsString = ''
}